import { css } from "styled-components";
export var accordionTransitionTiming = css([
    "transition-duration:0.25s;transition-timing-function:ease-out;"
]);
